// Copyright (c) Silence Laboratories Pte. Ltd.
// This software is licensed under the Silence Laboratories License Agreement.

import React, { FC } from 'react';

interface ErrorToastProps {
  msg: string;
}

export const ErrorToast: FC<ErrorToastProps> = ({ msg }) => (
  <div
    className="flex bg-[#261212] w-[328px] b2-regular"
    style={{
      borderRadius: '8px',
      padding: '16px 8px',
      color: '#FECACA',
      borderLeft: '2px solid #F87171',
    }}>
    <svg
      style={{ marginTop: '2px' }}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none">
      <path
        d="M8 2.25C4.55375 2.25 1.75 5.05375 1.75 8.5C1.75 11.9462 4.55375 14.75 8 14.75C11.4462 14.75 14.25 11.9462 14.25 8.5C14.25 5.05375 11.4462 2.25 8 2.25ZM8 4.8125C8.1607 4.8125 8.31779 4.86015 8.4514 4.94943C8.58502 5.03871 8.68916 5.1656 8.75065 5.31407C8.81215 5.46253 8.82824 5.6259 8.79689 5.78351C8.76554 5.94112 8.68815 6.08589 8.57452 6.19952C8.46089 6.31315 8.31612 6.39054 8.15851 6.42189C8.0009 6.45324 7.83753 6.43715 7.68907 6.37565C7.5406 6.31416 7.41371 6.21002 7.32443 6.0764C7.23515 5.94279 7.1875 5.7857 7.1875 5.625C7.1875 5.40951 7.2731 5.20285 7.42548 5.05048C7.57785 4.8981 7.78451 4.8125 8 4.8125ZM9.5 11.875H6.75C6.61739 11.875 6.49021 11.8223 6.39645 11.7286C6.30268 11.6348 6.25 11.5076 6.25 11.375C6.25 11.2424 6.30268 11.1152 6.39645 11.0214C6.49021 10.9277 6.61739 10.875 6.75 10.875H7.625V8.125H7.125C6.99239 8.125 6.86521 8.07232 6.77145 7.97855C6.67768 7.88479 6.625 7.75761 6.625 7.625C6.625 7.49239 6.67768 7.36521 6.77145 7.27145C6.86521 7.17768 6.99239 7.125 7.125 7.125H8.125C8.25761 7.125 8.38479 7.17768 8.47855 7.27145C8.57232 7.36521 8.625 7.49239 8.625 7.625V10.875H9.5C9.63261 10.875 9.75979 10.9277 9.85355 11.0214C9.94732 11.1152 10 11.2424 10 11.375C10 11.5076 9.94732 11.6348 9.85355 11.7286C9.75979 11.8223 9.63261 11.875 9.5 11.875Z"
        fill="#F87171"
      />
    </svg>
    <div className="flex-1 ml-1">{msg}</div>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path
        d="M9.06193 8.5013L12.0307 5.53255C12.1716 5.3919 12.2508 5.20105 12.251 5.00196C12.2512 4.80288 12.1723 4.61188 12.0316 4.47099C11.891 4.33009 11.7001 4.25084 11.501 4.25066C11.3019 4.25049 11.1109 4.3294 10.9701 4.47005L8.0013 7.4388L5.03255 4.47005C4.89165 4.32915 4.70056 4.25 4.5013 4.25C4.30204 4.25 4.11095 4.32915 3.97005 4.47005C3.82915 4.61095 3.75 4.80204 3.75 5.0013C3.75 5.20056 3.82915 5.39165 3.97005 5.53255L6.9388 8.5013L3.97005 11.4701C3.82915 11.6109 3.75 11.802 3.75 12.0013C3.75 12.2006 3.82915 12.3917 3.97005 12.5326C4.11095 12.6734 4.30204 12.7526 4.5013 12.7526C4.70056 12.7526 4.89165 12.6734 5.03255 12.5326L8.0013 9.5638L10.9701 12.5326C11.1109 12.6734 11.302 12.7526 11.5013 12.7526C11.7006 12.7526 11.8917 12.6734 12.0326 12.5326C12.1734 12.3917 12.2526 12.2006 12.2526 12.0013C12.2526 11.802 12.1734 11.6109 12.0326 11.4701L9.06193 8.5013Z"
        fill="#F87171"
      />
    </svg>
  </div>
);
